import * as Sentry from '@sentry/react'

const isProduction = process.env.ENVIRONMENT === 'prod'

if (isProduction) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    environment: process.env.ENVIRONMENT,
    release: process.env.DD_APP_VERSION,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        mutationBreadcrumbLimit: 1000,
        mutationLimit: 1500,
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: Number(process.env.SENTRY_TRACES_SAMPLE_RATE),
    replaysSessionSampleRate: Number(process.env.SENTRY_REPLAYS_SESSION_SAMPLE_RATE),
    replaysOnErrorSampleRate: Number(process.env.SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE),
  })
}
